import { render, staticRenderFns } from "./sanyaosu.vue?vue&type=template&id=9a23adba&scoped=true"
import script from "./sanyaosu.vue?vue&type=script&lang=js"
export * from "./sanyaosu.vue?vue&type=script&lang=js"
import style0 from "./sanyaosu.vue?vue&type=style&index=0&id=9a23adba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a23adba",
  null
  
)

export default component.exports